export const NO_PREFIX_URL = 'no-prefix-api'

export default {
  NO_PREFIX_URL
}
